import React from 'react';
import { NodeTreeItem } from 'djedi-json';
import { GetServerSideProps, NextPage } from 'next';
import Link from 'next/link';
import { STORY } from 'routes';

import { getExhibitionNode } from 'api';
import { ExhibitionVariant } from 'api/endpoints/cms';
import Container from 'components/Container';
import ExhibitionCard from 'components/ExhibitionCard';
import Grid from 'components/Grid';
import MetaTitle from 'components/MetaTitle';
import Layout from 'containers/Layout';
import Main from 'containers/Main';
import { sortExhibitions } from 'utils';
import exhibitionThumbnail from 'utils/exhibitionThumbnail';

type ExhibitListProps = {
  stories: NodeTreeItem[];
};

const ExhibitList: NextPage<ExhibitListProps> = ({ stories: rawStories }) => {
  const stories = sortExhibitions(rawStories);

  return (
    <>
      <MetaTitle>Stories</MetaTitle>
      <Layout>
        <Main paddingTop>
          <Container>
            <Grid columns={2}>
              {stories.map((ex, i) => {
                const { slug, title, subtitle } = ex.content;

                const story = {
                  slug,
                  title,
                  subtitle,
                  image: exhibitionThumbnail(ex) || '',
                };

                return (
                  <Link key={i} href={{ pathname: STORY.pathname, query: { slug } }}>
                    <ExhibitionCard flip exhibition={story} />
                  </Link>
                );
              })}
            </Grid>
          </Container>
        </Main>
      </Layout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  const { data: stories } = await getExhibitionNode({ variant: ExhibitionVariant.STORY });

  return {
    props: { stories: stories?.map(({ values }) => values) },
  };
};

export default ExhibitList;
